  jQuery(document).ready(function($) {

    $('.guide_nav__header').on('click', function () {
      $(this).next('.guide_nav__content').stop(true, true).slideToggle(400);
  
      $(this).closest('.guide_nav').toggleClass('active');
    });

    new Swiper('.flagship_slider', {
      slidesPerView: 1,
      spaceBetween: 36,
      speed: 600,
      effect: "fade",
  
      pagination: {
          el: '.flagship_slider .swiper-pagination',
          clickable: true
      },
  
      navigation: {
          nextEl: '.flagship_slider .swiper-button-next',
          prevEl: '.flagship_slider .swiper-button-prev'
      }
    });

    // Mandelic Guide
    new Swiper('.skin_swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
  
      pagination: {
          el: '.skin_swiper .swiper-pagination',
          clickable: true
      },
  
      navigation: {
          nextEl: '.skin_swiper .swiper-button-next',
          prevEl: '.skin_swiper .swiper-button-prev'
      },
  
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 60
        }
      }
    });

    new Swiper(".ff3_testimonial_Swiper", {
    loop:true,
    slidesPerView: 1,
    speed: 600,
    navigation: {
        nextEl: ".ff3_testimonial_Swiper .swiper-button-next",
        prevEl: ".ff3_testimonial_Swiper .swiper-button-prev",
    },
    pagination: {
      el: '.ff3_testimonial_Swiper .swiper-pagination',
      clickable: true
    },
  });

  new Swiper(".essential-products", {
    loop:false,
    slidesPerView: 1,
    gap: 20,
    speed: 600,
    navigation: {
        nextEl: ".essential-products .swiper-button-next",
        prevEl: ".essential-products .swiper-button-prev",
    },
    // pagination: {
    //   el: '.essential-products .swiper-pagination',
    //   clickable: true
    // },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      renderFraction: function(currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
                 ' / ' +
                 '<span class="' + totalClass + '"></span>';
      }
    },
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 2
      },
      1440: {
        slidesPerView: 3
      }
    }
  });


    // for Home hero slider
    var swiper = new Swiper(".heroSwiper", {
      loop: true,
      autoplay: { delay: 5000 },
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      effect: "fade"
    });

    //   for huamburger menu
    $(".header__hamburger").click(function() {
      $(".header__menu").toggleClass("open");
    });

    $(".header__search-toggle").on("click", function () {
      $(".header-search-bar").slideToggle(250);
      $("body").toggleClass('no-scroll');
      $("body").toggleClass('search-open');
      $("#ajax-search").focus();
    });



    $(".has-mega").each(function () {
      let timer;
      const $item = $(this);
      const $menu = $item.find(".mega-menu");

      $item.add($menu).hover(
        function () {
          clearTimeout(timer);

          // close all others instantly
          $(".mega-menu")
            .not($menu)
            .stop(true, true)
            .fadeOut(150)
            .removeClass("visible");

          // open this one instantly
          $menu
            .stop(true, true)
            .fadeIn(150)
            .addClass("visible");
        },
        function () {
          timer = setTimeout(() => {
            $menu
              .stop(true, true)
              .fadeOut(200)
              .removeClass("visible");
          }, 250); // delay only when leaving
        }
      );
    });

    $(document).on('click', '.quote_toggle_heading', function () {
      const $parent = $(this).closest('.dr_shion_quote_media');
      $parent.find('.context').slideToggle(300);
      $parent.toggleClass('open');
    });

    $(document).on('click', '.quote_toggle_heading', function () {
      const $parent = $(this).closest('.ff3_testimonial_row');
      $parent.find('.ff3_testimonial_context').slideToggle(300);
      $parent.toggleClass('open');
    });

    $(document).on('click', '.solid_triangle', function () {
      const $current = $(this).closest('.cma_row .col_item');
    
      $('.cma_row .col_item').not($current)
        .removeClass('open')
        .find('.bg-image').slideUp(300);
    
      $current.toggleClass('open')
        .find('.bg-image').slideToggle(300);
    });    
    
    
  
    // Close when clicking outside
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(".header-search-bar").length &&
        !$(e.target).closest(".header__search-toggle").length
      ) {
        $(".header-search-bar").slideUp(200);
        $("body").removeClass('no-scroll');
        $("body").removeClass('search-open');
      }
    });

    // Faq
    $(document).on("click", ".acc-header", function () {
      let item = $(this).closest(".acc-item");       // current item
      let content = item.find(".acc-content");       // its content

      if (item.hasClass("active")) {

          // CLOSE current
          content.stop(true, true).animate(
            { height: "0", paddingTop: "0px", paddingBottom: "0px" },
            300
          );
          item.removeClass("active");

      } else {

          // CLOSE all others
          $(".acc-item.active .acc-content").each(function(){
              $(this).stop(true, true).animate(
                { height: "0", paddingTop: "0px", paddingBottom: "0px" },
                300
              );
          });
          $(".acc-item").removeClass("active");

          // OPEN target
          let fullHeight = content.prop("scrollHeight");

          content.stop(true, true).animate(
            { height: fullHeight + "px", paddingBottom: "20px" },
            300
          );
          setTimeout(()=>{
            content.css({ height: "auto"})
          },400);

          item.addClass("active");
      }
    });

    // default scroll
    $('.scroll-link').on('click', function(e) {
      e.preventDefault();
      var target = $($(this).attr('href'));
      if (target.length) {
          $('html, body').animate({
              scrollTop: target.offset().top
          }, 600);
      }
    });

    // Reviews Click

    $(".jdgm-preview-badge").on("click", function (e) {
      e.preventDefault();
    
      let item = $(".acc-header").filter(function () {
        return $(this).text().toLowerCase().includes("reviews");
      }).closest(".acc-item");
    
      let content = item.find(".acc-content");
    
      if (!item.length) return;
    
      $("html, body").animate(
        { scrollTop: item.offset().top - 100 },
        500,
        function () {
          if (!item.hasClass("active")) {
    
            $(".acc-item.active .acc-content").stop(true, true).animate(
              { height: "0", paddingTop: "0px", paddingBottom: "0px" },
              300
            );
            $(".acc-item").removeClass("active");
    
            let fullHeight = content.prop("scrollHeight");
            content.stop(true, true).animate(
              { height: fullHeight + "px", paddingBottom: "20px" },
              300
            );
    
            item.addClass("active");
          }
        }
      );
    });
    
    

    // Filter open
    $(document).on('click', '.show_filter', function (e) {
      e.preventDefault();
      $(this).closest('.horizontal-facet-filter-bar').toggleClass('open_filter');
    });

      
    // new Swiper(".productSwiper", {
    //   loop: true,
      
    //   speed: 600,
      
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev"
    //   },
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true
    //   },
    //   breakpoints: {
    //     0: {
    //       slidesPerView: 1.1
    //     },
    //     768: {
    //       slidesPerView: 1,
    //       effect: 'fade',
    //       fadeEffect: {
    //         crossFade: true
    //       },
    //     }
    //   }
    // });
    new Swiper(".recommendation_swiper", {
      loop: false,
      speed: 600,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: 10
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 24
        }
      }
    });

    new Swiper(".productkey_ingredients_swiper", {
      loop: true,
      // slidesPerView: 3,
      // spaceBetween: 60,
      speed: 600,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        1600: {
          slidesPerView: 3,
          spaceBetween: 61
        }
      }
    });
    new Swiper(".build_my_own__products_swiper", {
      loop: false,
      spaceBetween: 30,
      speed: 600,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 2.5,
          spaceBetween: 12
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 30
        }
      }
    });

    new Swiper(".mobile_product_slider", {
      loop: false,
      spaceBetween: 10,
      speed: 600,
      slidesPerView: 1.3,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 60
        }
      }
    });

    new Swiper(".product_video_slider", {
      loop: false,
      spaceBetween: 10,
      speed: 600,
      slidesPerView: 2,
      centeredSlides: false,
      watchOverflow: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          // centeredSlides: true
        },
        768: {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 4
        },
        1440: {
          slidesPerView: 5,
        }
      },
      // on: {
      //   init: function () {
      //     handleSlideMedia(this);
      //   },
      //   slideChange: function () {
      //     handleSlideMedia(this);
      //   }
      // }
    });

    new Swiper(".mobile_expert_favo_slider", {
      loop: true,
      spaceBetween: 10,
      speed: 600,
      slidesPerView: 1.2
    });
    new Swiper(".mobile_blogs_slider", {
      loop: true,
      spaceBetween: 10,
      speed: 600,
      slidesPerView: 1.2
    });


  });


  document.addEventListener("DOMContentLoaded", () => {

    const toggle = document.querySelector(".drawer-toggle");
    const drawer = document.querySelector(".drawer");
    const overlay = document.querySelector(".drawer-overlay");
    const closeBtn = document.querySelector(".drawer-close");
  
    function openDrawer() {
      drawer.classList.add("open");
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  
    function closeDrawer() {
      drawer.classList.remove("open");
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      document.querySelector('.main-mobile-nav').classList.remove('megamenu-open');
      document.querySelectorAll('.mega-mobile--menu-inner').forEach(el=>el.classList.remove('is-mega-open'));
      document.querySelectorAll('.has-megamenu').forEach(el=>el.classList.remove('open'));
    }
  
    toggle.addEventListener("click", openDrawer);
    closeBtn.addEventListener("click", closeDrawer);
    overlay.addEventListener("click", closeDrawer);
  });
  // Product Gallery
  document.addEventListener('click', function (e) {
    /* ---------------------------------
     1. HAS MEGA MENU CLICK
    ---------------------------------- */
    const megaTrigger = e.target.closest('.has-megamenu > a');
    if (megaTrigger) {
      const megaItem = megaTrigger.closest('.has-megamenu');
      const mainMobileNav = document.querySelector('.main-mobile-nav');
      if (!megaItem) return;
      

      // Close other mega menus
      document.querySelectorAll('.has-megamenu.open').forEach((item) => {
        if (item !== megaItem) {
          item.classList.remove('open');
          const wrap = item.querySelector('.mega-mobile--menu-inner');
          wrap && wrap.classList.remove('is-mega-open');
        }
      });

      mainMobileNav.classList.toggle('megamenu-open');

      // Toggle current
      megaItem.classList.toggle('open');

      const wrapper = megaItem.querySelector('.mega-mobile--menu-inner');
      if (wrapper) {
        wrapper.classList.toggle('is-mega-open', megaItem.classList.contains('open'));
      }

      e.preventDefault();
      return;
    }

    /* ---------------------------------
     2. SUBMENU H4 CLICK
    ---------------------------------- */
    const submenuTitle = e.target.closest('.mega-mobile--submenu h4');
    if (submenuTitle) {
      const submenu = submenuTitle.closest('.mega-mobile--submenu');
      const wrapper = submenu.closest('.mega-mobile--menu-inner');
      if (!submenu || !wrapper) return;

      // Close other submenus
      wrapper.querySelectorAll('.mega-mobile--submenu.open').forEach((item) => {
        if (item !== submenu) item.classList.remove('open');
      });

      // Open current submenu
      submenu.classList.toggle('open');

      // Mark wrapper as submenu-open
      wrapper.classList.toggle('has-submenu-open', wrapper.querySelector('.mega-mobile--submenu.open'));

      e.preventDefault();
      return;
    }
  });